// Auto-generated by scripts/generate-build-info.mjs
// Do not edit manually. Regenerated on every build.

export interface BuildInfo {
  version: string;
  buildNumber: number;
  buildDate: string;
}

export const BUILD_INFO: BuildInfo = {
  "version": "0.1.0",
  "buildNumber": 15,
  "buildDate": "2026-04-19T12:16:12.038Z"
};
